export default "__VITE_ASSET__DZPfrY5p__"